import React from 'react';
import { BadgeCheckIcon, StarIcon } from 'lucide-react';
interface TrustRatingProps {
  className?: string;
}

/**
 * Widget de valoración estilo reseñas verificadas: cinco estrellas sobre
 * mosaicos verdes + sello de verificado.
 */
export function TrustRating({
  className = ''
}: TrustRatingProps) {
  return <div className={`flex flex-wrap items-center justify-center gap-4 sm:justify-start ${className}`} data-id="element-537" data-mp="2akcclquqzh21">
      <div className="flex items-center gap-3" data-id="element-538" data-mp="1murrb1b4g7pl">
        <span className="flex gap-0.5" aria-hidden="true" data-id="element-539" data-mp="1mvjmib0t43fc">
          {Array.from({
          length: 5
        }).map((_, index) => <span key={index} className="flex h-7 w-7 items-center justify-center rounded-[3px] bg-leaf" data-id="element-540" data-mp="1wsfnlvodln9v" data-mpi={index}>
              <StarIcon className="h-4 w-4 fill-white text-white" data-id="element-541" data-mp="1rsa0mst1woy4" />
            </span>)}
        </span>
        <p className="text-sm font-bold text-ink" data-id="element-542" data-mp="386jozmxamdoy">
          4,9<span className="font-medium text-muted" data-id="element-543" data-mp="3895xbos0cx88"> / 5</span>
        </p>
      </div>

      <span className="hidden h-6 w-px bg-mist sm:block" aria-hidden="true" data-id="element-544" data-mp="337qd1yxnmuqw" />

      <p className="flex items-center gap-2 text-xs font-semibold text-forest sm:text-sm" data-id="element-545" data-mp="afrbtg8q9ihy">
        <BadgeCheckIcon className="h-5 w-5 text-leaf" aria-hidden="true" data-id="element-546" data-mp="fem6pgjyyxif" />
        Reseñas verificadas de compradoras
      </p>
    </div>;
}